import { ToggleValue } from "./Toggle";

export const ToggleTestPageObject = (
    value: ToggleValue,
    checkedValue: ToggleValue,
    handleChange: (checked?: boolean) => void
) => ({
    getType: () => "Toggle",

    isChecked: (): boolean => value === checkedValue,

    setChecked: handleChange,
});
